export function ColoredCrispyVoiceLogoWithText({ className }: { className?: string }) {
    return (
        <svg
            id='Logo'
            className={className}
            viewBox='0 0 520 77.17'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
        >
            <defs>
                <style>
                    {`
      .cls-1 {
        fill: url(#linear-gradient);
      }

      .cls-2 {
        fill: currentColor;
      }

      .cls-3 {
        fill: url(#linear-gradient-2);
      }`}
                </style>
                <linearGradient
                    id='linear-gradient'
                    x1='-164.71'
                    y1='1130.74'
                    x2='-164.71'
                    y2='1079.4'
                    gradientTransform='translate(202.5 1156.17) scale(1 -1)'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0' stopColor='#0b9dd9' />
                    <stop offset='1' stopColor='#2e84c6' />
                </linearGradient>
                <linearGradient
                    id='linear-gradient-2'
                    x1='-158.26'
                    y1='1156.17'
                    x2='-158.26'
                    y2='1114.4'
                    xlinkHref='#linear-gradient'
                />
            </defs>
            <g>
                <path
                    className='cls-1'
                    d='m75.38,25.43l-16.46,16.35-16.46,16.47-16.21-16.25,16.44-16.48-.09-.1h-25.63L0,42.41l29.15,29.13.06.05c3.22,3.09,7.44,4.92,11.89,5.16,4.45.24,8.85-1.13,12.38-3.85.25-.18,22.1-22.04,22.1-22.04l-.2-25.42Z'
                />
                <path
                    className='cls-3'
                    d='m42.66,25.5l-.09.1,16.18,16.18.05-.55v-24.79L42.37,0l-12.69,12.69,12.79,12.79.2.02Z'
                />
            </g>
            <g>
                <path
                    className='cls-2'
                    d='m142.04,50.13c-1.05,6.88-7,11.15-15.54,11.15-11.83,0-17.14-8.2-17.14-16.32,0-9.54,6.8-15.7,17.33-15.7,2.85,0,12.35.61,14.61,8.33l.16.58,9.59-.66-.27-.89c-2.73-9.01-11.51-14.17-24.09-14.17-16.12,0-27.37,9.31-27.37,22.65s11.12,22.96,27.06,22.96c13.78,0,23.73-6.94,25.35-17.68l.13-.86h-9.74l-.09.62Z'
                />
                <path
                    className='cls-2'
                    d='m175.44,34.49c-4.63,0-8.07,1.26-10.12,3.65v-3.22h-8.75v32.1h9.48v-16.68c0-5.17,4.47-9.07,10.41-9.07.87,0,1.9.12,3.34.35l.84.15v-6.31l-.48-.18c-1.39-.52-3.02-.79-4.72-.79Z'
                />
                <path className='cls-2' d='m195.96,34.92h-9.48v32.1h9.48v-32.1Z' />
                <path
                    className='cls-2'
                    d='m225.08,47.92l-9.57-1.85c-2.76-.54-4.16-1.4-4.16-2.56,0-2.4,4.47-3.03,7.1-3.03,5.06,0,7.54,1.41,8.56,4.85l.16.53h8.98l-.1-.82c-.88-6.79-7-10.53-17.22-10.53-6.68,0-16.62,2.54-16.62,9.57,0,6.25,7.72,7.73,12.34,8.63l8.43,1.59c2.98.57,5.68,1.28,5.68,3.44,0,3.22-5.37,4.09-8.53,4.09-2.84,0-9.54-.57-10.32-5.85l-.09-.63h-9.19l.1.82c.93,7.4,7.97,11.65,19.32,11.65,8.88,0,17.85-3.19,17.85-10.31,0-6.28-6.43-8.35-12.71-9.56v-.03Z'
                />
                <path
                    className='cls-2'
                    d='m264.24,34.1c-4.58,0-8.56,1.07-12.11,3.27v-2.46h-9.48v41.58h9.48v-12.38c3.24,2.31,7.54,3.48,12.8,3.48,11.38,0,18.74-6.48,18.74-16.54s-7.63-16.97-19.44-16.97Zm-1.81,6.42c7.19,0,10.99,3.69,10.99,10.68s-3.86,10.74-10.86,10.74-10.99-3.75-10.99-10.87,3.86-10.56,10.87-10.56h-.01Z'
                />
                <path
                    className='cls-2'
                    d='m309.04,53.48c-.49.99-1.2,2.59-2.17,4.95-.87-1.85-1.68-3.47-2.46-4.95l-9.25-17.83h-10.09l16.44,28.73c.72,1.24.75,2.27.07,3.63l-.1.27c-1.43,2.95-4.25,3.55-9.74,2.02l-.93-.25v5.94l.55.15c2.51.69,4.77,1.03,6.79,1.03,4.97,0,8.51-2.1,10.73-6.31l18.74-35.22h-9.81l-8.75,17.85h0Z'
                />
                <path
                    className='cls-2'
                    d='m396.59,34.51c-10.25,0-20.59,5.16-20.59,16.69s10.34,16.75,20.59,16.75c12.16,0,20.65-6.78,20.65-16.5,0-11.7-10.37-16.93-20.65-16.93h0Zm10.94,16.87c0,6.71-4.08,10.56-11.18,10.56s-11.18-3.81-11.18-10.74,4.08-10.68,11.18-10.68c4.18,0,11.18,1.42,11.18,10.87h0Z'
                />
                <path className='cls-2' d='m430.88,34.92h-9.48v32.1h9.48v-32.1Z' />
                <path
                    className='cls-2'
                    d='m368.7,23.25l-12.21,27.95c-.87,2.13-1.88,4.57-2.89,7.33-1.17-2.93-2.16-5.3-3.08-7.34l-12.45-27.93h-10.3l20.92,43.77h9.71l20.47-43.77h-10.17Z'
                />
                <path className='cls-2' d='m430.88,23.98h-9.48v8.03h9.48v-8.03Z' />
                <path className='cls-2' d='m195.96,23.98h-9.48v8.03h9.48v-8.03Z' />
                <path
                    className='cls-2'
                    d='m466.63,55.14c-1.04,4.44-4.27,6.61-9.86,6.61-7,0-11.34-3.97-11.34-10.38s4.44-10.21,11.34-10.21c5.07,0,8.2,1.9,9.34,5.63l.16.51h8.57l-.14-.82c-1.15-6.94-7.85-11.09-17.93-11.09-12.38,0-20.38,6.29-20.38,16.04s8,16.1,20.38,16.1c10.4,0,17.27-4.53,18.35-12.12l.11-.81h-8.47l-.13.55v-.03Z'
                />
                <path
                    className='cls-2'
                    d='m510.46,56.94c-1.79,3.41-4.85,5.01-9.59,5.01-6.17,0-10.19-3.24-10.92-8.79h30.05l-.03-.68c-.41-11.58-7.19-17.96-19.1-17.96s-20.34,6.71-20.34,16.69,8.36,16.75,20.34,16.75c9.38,0,16.25-3.9,18.39-10.44l.31-.71h-8.91l-.21.13Zm-20.43-8.89c.8-5.35,6.04-7.27,10.84-7.27,3.96,0,8.72,1.29,9.32,7.27h-20.17Z'
                />
            </g>
        </svg>
    );
}
